import PropTypes from 'prop-types';

/**
 * This doesn't render anything, just for the schmea of the SMCTabsContainer.
 * title and children that are passed are used by SMCTabsContainer.
 */
function SMCTab({
    title,
    id,
    children
}) {
    return null;
}

SMCTab.propTypes = {
    title: PropTypes.string.isRequired,
    id: PropTypes.string,
    children: PropTypes.node.isRequired
}

export default SMCTab;